import { render, staticRenderFns } from "./BalanceDetailsFundCard.vue?vue&type=template&id=401d9410&scoped=true"
import script from "./BalanceDetailsFundCard.vue?vue&type=script&lang=js"
export * from "./BalanceDetailsFundCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceDetailsFundCard.vue?vue&type=style&index=0&id=401d9410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d9410",
  null
  
)

export default component.exports